import type { ComicItem } from '@/mocks/comicData';

interface ComicCardProps {
  item: ComicItem;
  showType?: boolean;
}

export default function ComicCard({ item, showType = false }: ComicCardProps) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}漫画封面`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-xs font-semibold text-background-50 ${
            item.status === '连载中' ? 'bg-primary-500' : 'bg-secondary-600'
          }`}
        >
          {item.status}
        </span>
        {showType && (
          <span className="absolute right-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-semibold text-background-50">
            {item.type === 'guoman' ? '国漫' : '日漫'}
          </span>
        )}
        <span className="absolute bottom-2 left-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
          {item.score}分
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{item.title}</h3>
        <p className="line-clamp-2 text-xs leading-5 text-foreground-600 md:text-[13px]">{item.intro}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-1">
          {item.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-1 flex items-center justify-between border-t border-background-200 pt-2 text-[11px] text-foreground-500">
          <span className="font-medium text-primary-600">{item.latest}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {item.views}
          </span>
        </div>
      </div>
    </article>
  );
}